const data = {
	"width": 512,
	"height": 512,
	"body": "<mask id=\"circleFlagsRo0\"><circle cx=\"256\" cy=\"256\" r=\"256\" fill=\"#fff\"/></mask><g mask=\"url(#circleFlagsRo0)\"><path fill=\"#ffda44\" d=\"M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z\"/><path fill=\"#0052b4\" d=\"M0 0h167v512H0z\"/><path fill=\"#d80027\" d=\"M345 0h167v512H345z\"/></g>"
};
exports.__esModule = true;
exports.default = data;
